import React from "react";

const states = {
  requested: {
    icon: "📄",
    title: "No loan requests yet",
    description:
      "Check your property's value and send one request to multiple lenders.",
  },
  accepted: {
    icon: "🤝",
    title: "No accepted offers yet",
    description:
      "Once lenders send offers, compare rates, fees and tenure side by side, then accept the one that suits you.",
  },
  ongoing: {
    icon: "🏠",
    title: "No ongoing loans",
    description:
      "Disbursed loans show here with repayment dates, balances and redemption status.",
  },
};

export default function PropertyLoanEmptyState({ type, onStart }) {
  const state = states[type];
  return (
    <section className="pl-tab-empty" aria-labelledby={`pl-empty-${type}`}>
      <div className="pl-empty-icon" aria-hidden="true">
        {state.icon}
      </div>
      <h3 id={`pl-empty-${type}`}>{state.title}</h3>
      <p>{state.description}</p>
      <button type="button" className="pl-primary" onClick={onStart}>
        Start an application
      </button>
    </section>
  );
}
